import React from 'react';
import CaseStudyBrowserHero from './CaseStudyBrowserHero';

const CaseStudyBrowserHeroWithProps = (props: any) => {
  return (
    <CaseStudyBrowserHero
      label={props.label}
      featuredCaseStudy={props.featuredCaseStudy}
    />
  );
};

export default CaseStudyBrowserHeroWithProps;
